module.exports = __webpack_public_path__ + "img/12.b339a7fd.png";